module.exports = __webpack_public_path__ + "img/Angiogenesis-PDAC_GSE111672.2c307926.png";